import {ThemeFonts} from '../system'

export const defaultThemeFonts: ThemeFonts = {
  code: {
    family: 'ui-monospace, SFMono-Regular, SF Mono, Menlo, Consolas, Liberation Mono, monospace',
    weights: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    sizes: [
      {
        ascenderHeight: 4,
        descenderHeight: 4,
        fontSize: 10,
        iconSize: 17,
        lineHeight: 15,
        letterSpacing: 0,
      },
      {
        ascenderHeight: 5,
        descenderHeight: 5,
        fontSize: 13,
        iconSize: 21,
        lineHeight: 19,
        letterSpacing: 0,
      },
      {
        ascenderHeight: 6,
        descenderHeight: 6,
        fontSize: 16,
        iconSize: 25,
        lineHeight: 23,
        letterSpacing: 0,
      },
      {
        ascenderHeight: 7,
        descenderHeight: 7,
        fontSize: 19,
        iconSize: 29,
        lineHeight: 27,
        letterSpacing: 0,
      },
      {
        ascenderHeight: 8,
        descenderHeight: 8,
        fontSize: 22,
        iconSize: 33,
        lineHeight: 31,
        letterSpacing: 0,
      },
    ],
  },
  heading: {
    family:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", "Liberation Sans", Helvetica, Arial, system-ui, sans-serif',
    weights: {
      regular: 700,
      medium: 800,
      semibold: 900,
      bold: 900,
    },
    sizes: [
      {
        ascenderHeight: 5,
        descenderHeight: 5,
        fontSize: 13,
        iconSize: 17,
        lineHeight: 19,
        letterSpacing: 0,
      },
      {
        ascenderHeight: 6,
        descenderHeight: 6,
        fontSize: 16,
        iconSize: 25,
        lineHeight: 23,
        letterSpacing: 0,
      },
      {
        ascenderHeight: 7,
        descenderHeight: 7,
        fontSize: 21,
        iconSize: 33,
        lineHeight: 29,
        letterSpacing: 0,
      },
      {
        ascenderHeight: 8,
        descenderHeight: 8,
        fontSize: 27,
        iconSize: 41,
        lineHeight: 35,
        letterSpacing: 0,
      },
      {
        ascenderHeight: 9.5,
        descenderHeight: 8.5,
        fontSize: 33,
        iconSize: 49,
        lineHeight: 41,
        letterSpacing: 0,
      },
      {
        ascenderHeight: 10.5,
        descenderHeight: 9.5,
        fontSize: 38,
        iconSize: 53,
        lineHeight: 47,
        letterSpacing: 0,
      },
    ],
  },
  label: {
    family:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", "Liberation Sans", system-ui, sans-serif',
    weights: {
      regular: 600,
      medium: 700,
      semibold: 800,
      bold: 900,
    },
    sizes: [
      {
        ascenderHeight: 2,
        descenderHeight: 2,
        fontSize: 8.1,
        iconSize: 13,
        lineHeight: 10,
        letterSpacing: 0.5,
      },
      {
        ascenderHeight: 2,
        descenderHeight: 2,
        fontSize: 9.5,
        iconSize: 15,
        lineHeight: 11,
        letterSpacing: 0.5,
      },
      {
        ascenderHeight: 2,
        descenderHeight: 2,
        fontSize: 10.8,
        iconSize: 17,
        lineHeight: 12,
        letterSpacing: 0.5,
      },
      {
        ascenderHeight: 2,
        descenderHeight: 2,
        fontSize: 12.25,
        iconSize: 19,
        lineHeight: 13,
        letterSpacing: 0.5,
      },
      {
        ascenderHeight: 2,
        descenderHeight: 2,
        fontSize: 13.6,
        iconSize: 21,
        lineHeight: 14,
        letterSpacing: 0.5,
      },
      {
        ascenderHeight: 2,
        descenderHeight: 2,
        fontSize: 15,
        iconSize: 23,
        lineHeight: 15,
        letterSpacing: 0.5,
      },
    ],
  },
  text: {
    family:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", "Liberation Sans", Helvetica, Arial, system-ui, sans-serif',
    weights: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    sizes: [
      {
        ascenderHeight: 4,
        descenderHeight: 4,
        fontSize: 10,
        iconSize: 17,
        lineHeight: 15,
        letterSpacing: 0,
      },
      {
        ascenderHeight: 5,
        descenderHeight: 5,
        fontSize: 13,
        iconSize: 21,
        lineHeight: 19,
        letterSpacing: 0,
      },
      {
        ascenderHeight: 6,
        descenderHeight: 6,
        fontSize: 15,
        iconSize: 25,
        lineHeight: 23,
        letterSpacing: 0,
      },
      {
        ascenderHeight: 7,
        descenderHeight: 7,
        fontSize: 18,
        iconSize: 29,
        lineHeight: 27,
        letterSpacing: 0,
      },
      {
        ascenderHeight: 8,
        descenderHeight: 8,
        fontSize: 21,
        iconSize: 33,
        lineHeight: 31,
        letterSpacing: 0,
      },
    ],
  },
}
